import { render } from "./FormView.vue?vue&type=template&id=23e9b3e8"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=23e9b3e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__